import React from 'react'
import { Helmet } from 'react-helmet'
import policy from '../images/Policy-Compliance.png'
function PolicyCompliance() {
    return (
        <div>
            <Helmet>
                <title>Parcelx - Policy Compliance</title>
            </Helmet>
            <section className='section01 pb-0 trmsss'>
            <div className='container-fluid'>
                <div className='col-md-11 mx-auto'>
                    <div className="row align-items-center">
                        <div className="col-md-4 order-md-2 text-md-end">
                            <img src={policy} height="350" alt="" />
                        </div>
                        <div className="col-lg-8">
                            <h1 className="display-3 font-weight-normal">Policy Compliance</h1>
                            <p className="text-muted">The ParcelX Logistics Seller App operates independently and does not engage in any form of differential treatment towards any logistics buyer.</p>
                            <p className="text-muted">Updated on 03rd October 2023</p>
                            <p className="text-muted">For any queries, please contact <span><a href="https://mail.google.com/mail/?view=cm&fs=1&to=support@parcelx.in" target="_blank" rel="noopener noreferrer"> support@parcelx.in</a></span></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>
    )
}

export default PolicyCompliance
